module.exports = "/_next/static/images/bg-30c8a656.png";